import styled from "styled-components";

export const Footer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    margin-top: 50px;
`